import { getStorageItem } from "./storage";

const getDateFormat = (): string => {
    const settings = getStorageItem<{ dateFormat?: string }>("twindix_perf_settings");
    return settings?.dateFormat ?? "MMM D, YYYY";
};

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const pad = (n: number) => n.toString().padStart(2, "0");

const applyFormat = (date: Date, fmt: string): string => {
    const d = date.getDate();
    const m = date.getMonth();
    const y = date.getFullYear();

    switch (fmt) {
        case "DD/MM/YYYY": return `${pad(d)}/${pad(m + 1)}/${y}`;
        case "MM/DD/YYYY": return `${pad(m + 1)}/${pad(d)}/${y}`;
        case "YYYY-MM-DD": return `${y}-${pad(m + 1)}-${pad(d)}`;
        default: return `${months[m]} ${d}, ${y}`;
    }
};

export const formatDate = (dateStr: string): string => {
    return applyFormat(new Date(dateStr), getDateFormat());
};

export const formatDateTime = (dateStr: string): string => {
    const date = new Date(dateStr);
    const datePart = applyFormat(date, getDateFormat());
    const timePart = date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false });
    return `${datePart}, ${timePart}`;
};

export const nowLocalDT = (): string => {
    const d = new Date();
    d.setSeconds(0, 0);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/** Convert a UTC ISO string from the API to a local datetime-local input value */
export const toLocalDT = (iso: string | null | undefined): string => {
    if (!iso) return "";
    const d = new Date(iso);
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const todayISO = (): string => {
    const d = new Date();
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const daysAgo = (dateStr: string): number => {
    const now = new Date();
    const date = new Date(dateStr);
    return Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
};

export const daysBetween = (start: string, end: string): number => {
    const s = new Date(start);
    const e = new Date(end);
    return Math.floor((e.getTime() - s.getTime()) / (1000 * 60 * 60 * 24));
};
